import { HelpCircle } from 'lucide-react'

interface PendingConsultationBadgeProps {
  /** Lo que el asistente no supo resolver; se muestra al pasar el cursor. */
  question?: string | null
}

/** Marca de la lista de chats: el asistente espera una respuesta del equipo. */
export function PendingConsultationBadge({ question }: PendingConsultationBadgeProps) {
  return (
    <span
      title={question ? `Duda por resolver: ${question}` : 'Hay una duda por resolver en este chat'}
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] font-black uppercase tracking-tighter border border-amber-400/60 text-amber-800 bg-amber-50 flex-shrink-0"
    >
      <HelpCircle className="h-2.5 w-2.5 text-amber-600" aria-hidden="true" />
      <span>Duda por resolver</span>
    </span>
  )
}
